// services/purchases/ImportPurchaseService.ts
import { importPurchaseApi } from '../../api';
import {
  ImportProduct,
  ImportProductUpdate,
} from '../../types/purchases/BasePurchase';

const ImportPurchaseService = {

  /**
   * Agregar un producto a una compra de importación
   * POST /api/import-purchases/products
   */
  addProduct: async (product: ImportProduct) => {
    const response = await importPurchaseApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * Actualizar un producto de una compra de importación
   * PUT /api/import-purchases/products
   */
  updateProduct: async (product: ImportProductUpdate) => {
    const response = await importPurchaseApi.modifyCustom('/products', product);
    return response.data;
  },

  /**
   * Eliminar un producto de una compra de importación
   * DELETE /api/import-purchases/products/{detailId}
   */
  deleteProduct: async (detailId: number) => {
    const response = await importPurchaseApi.removeCustom(`/products/${detailId}`);
    return response.data;
  },

  /**
   * Obtener un producto por su ID de detalle para editar
   * GET /api/import-purchases/products/{detailId}
   */
  getProductById: async (detailId: number) => {
    const response = await importPurchaseApi.fetchCustom(`/products/${detailId}`);
    return response.data
  },
};

export default ImportPurchaseService;
